import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_REPEAT: GlameraIconDefinition = {
  name: 'repeat',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-repeat-top-base" d="M3 11v-1a4 4 0 0 1 4-4h14"></path>
    <path class="glm-repeat-bottom-base" d="M21 13v1a4 4 0 0 1-4 4H3"></path>
    <path class="glm-repeat-top-pulse" pathLength="1" d="M3 11v-1a4 4 0 0 1 4-4h14"></path>
    <path class="glm-repeat-bottom-pulse" pathLength="1" d="M21 13v1a4 4 0 0 1-4 4H3"></path>
    <path class="glm-repeat-top-head" d="m17 2 4 4-4 4"></path>
    <path class="glm-repeat-bottom-head" d="m7 22-4-4 4-4"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-repeat-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './repeat.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class RepeatIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_REPEAT;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
